// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36jMS","content":"styles_content__3JBs0"};